
/*
 * @Author: Michael
 * @Date: 2018-09-18 15:30:07
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2021-08-19 11:33:01
 */
import {
  State,
  SelectBGMState,
  IntroItem,
  DescItem,
  SignatureData,
} from "@/common/interface";
import { BargainParameterState } from "@/common/interface/bargain_type";
import { TyTypeParameterState } from "@/common/interface/ty_type";
import { Ladder } from '@/common/interface/group_type';
import { Solitaire } from '@/common/interface/solitaire_type';
import { stat } from 'fs';

const getters = {
  xcxFlag(state: State): boolean {
    return state.xcxFlag;
  },
  isInvalid(state: State): boolean {
    return state.isInvalid;
  },
  isAgain(state: State): boolean {
    return state.isAgain;
  },
  madeByOrg(state: State): boolean {
    return state.madeByOrg;
  },
  instId(state: State): string {
    return state.instId;
  },
  leadersInstId(state: State): string {
    return state.leadersInstId;
  },
  payInstId(state: State): string {
    return state.payInstId;
  },
  orgId(state: State): string {
    return state.orgId;
  },
  instList(state: State): Array<object> {
    return state.instList;
  },
  instVOList(state: State): Array<object> {
    return state.instVOList;
  },
  instNameNot(state: State): Array<string> {
    return state.instNameNot;
  },
  instNameFew(state: State): Array<string> {
    return state.instNameFew;
  },
  instNameZero(state: State): Array<string> {
    return state.instNameZero;
  },
  instIds(state: State): Array<string> {
    return state.instIds;
  },
  openId(state: State): string {
    return state.openId;
  },
  uid(state: State): string {
    return state.uid;
  },
  name(state: State): string {
    return state.name;
  },
  phone(state: State): string {
    return state.phone;
  },
  signature(state: State): SignatureData {
    return state.signature;
  },
  documentTitle(state: State): string {
    return state.documentTitle;
  },
  originalTitle(state: State): string {
    return state.originalTitle;
  },
  qrCodeUrl(state: State): string {
    return state.qrCodeUrl || state.htmUrl;
  },
  topTips(state: State): string {
    return state.topTips;
  },
  gachaTypeParameter(state: State): object {
    return state.gachaTypeParameter;
  },
  distributeTypeParameter(state: State): object {
    return state.distributeTypeParameter;
  },
  mainBackgroundColor(state: State): string {
    return state.mainBackgroundColor;
  },
  mainTextColor(state: State): string {
    return state.mainTextColor;
  },
  gradientColor(state: State): string {
    return state.gradientColor;
  },

  section(state: State): object {
    return state.section;
  },

  /***** prizeIntros *****/
  sectionPrizeIntrosTextNum(state: State): number {
    const tempArr: Array<IntroItem> = state.section.prizeIntros.filter(item => {
      return item.type === 'text';
    });
    return tempArr.length;
  },
  sectionPrizeIntrosImgNum(state: State): number {
    const tempArr: Array<IntroItem> = state.section.prizeIntros.filter(item => {
      return item.type === 'img';
    });
    return tempArr.length;
  },
  /***** ***** *****/

  /***** courseIntros *****/
  sectioncourseIntrosTextNum(state: State): number {
    const tempArr: Array<IntroItem> = state.section.courseIntros.filter(item => {
      return item.type === 'text';
    });
    return tempArr.length;
  },
  sectionCourseIntrosImgNum(state: State): number {
    const tempArr: Array<IntroItem> = state.section.courseIntros.filter(item => {
      return item.type === 'img';
    });
    return tempArr.length;
  },
  /***** ***** *****/

  courseType(state: State): string {
    return state.section.courseType;
  },
  courseGroupList(state: State): any {
    return state.section.courseGroupList;
  },
  selectedSeqNo(state: State): any {
    return state.section.selectedSeqNo;
  },

  titleSection(state: State): object {
    return state.titleSection;
  },
  buttonSection(state: State): object {
    return state.buttonSection;
  },
  numberSection(state: State): object {
    return state.numberSection;
  },
  modalSection(state: State): object {
    return state.modalSection;
  },

  title(state: State): string {
    return state.title;
  },
  deadline(state: State): number {
    return state.deadline;
  },
  startTime(state: State): number {
    return state.startTime;
  },
  instName(state: State): string {
    return state.instName;
  },
  bgmList(state: State): Array<string> {
    return state.bgmList;
  },
  customizeBgmList(state: State): Array<string> {
    return state.customizeBgmList;
  },
  musicTagBgColor(state: State): string {
    return state.musicTagBgColor;
  },
  musicTagTextColor(state: State): string {
    return state.musicTagTextColor;
  },
  selectedBGM(state: State): SelectBGMState {
    return state.selectedBGM;
  },
  instPhone(state: State): string {
    if (typeof state.instPhone === 'object') {
      return (state.instPhone as any).instPhone;
    } else {
      return state.instPhone;
    }
  },
  instAddress(state: State): string {
    return state.instAddress;
  },
  wechatMiniOnlineStatus(state: State): string {
    return state.wechatMiniOnlineStatus;
  },
  xmPayRegisterStatusEnum(state: State): string {
    return state.xmPayRegisterStatusEnum;
  },

  isLimited(state: State): boolean {
    return state.isLimited;
  },
  limitNum(state: State): number {
    return state.limitNum;
  },
  canPay(state: State): boolean {
    return state.canPay;
  },
  hasOpenSMSVerify(state: State): boolean {
    return state.hasOpenSMSVerify;
  },
  mustMinPay(state: State): boolean {
    return state.mustMinPay;
  },
  payType(state: State): string {
    return state.payType;
  },
  payNumber(state: State): number {
    return state.payNumber;
  },
  virtualGroup(state: State): boolean {
    return state.virtualGroup;
  },

  activityRule(state: State): string {
    return state.activityRule;
  },
  activityTitle(state: State): string {
    return state.activityTitle;
  },
  activitySwitch(state: State): boolean {
    return state.activitySwitch;
  },
  activityIntros(state: State): Array<IntroItem> {
    return state.activityIntros;
  },
  activityIntrosTextNum(state: State): number {
    const tempArr: Array<IntroItem> = state.activityIntros.filter(item => {
      return item.type === 'text';
    });
    return tempArr.length;
  },
  activityIntrosImgNum(state: State): number {
    const tempArr: Array<IntroItem> = state.activityIntros.filter(item => {
      return item.type === 'img';
    });
    return tempArr.length;
  },
  contactInfo(state: State): string {
    return state.contactInfo;
  },
  contactTitle(state: State): string {
    return state.contactTitle;
  },
  contactSwitch(state: State): boolean {
    return state.contactSwitch;
  },

  institutionTitle(state: State): string {
    return state.institutionTitle;
  },
  institutionSwitch(state: State): boolean {
    return state.institutionSwitch;
  },
  institutionIntros(state: State): Array<IntroItem> {
    return state.institutionIntros;
  },
  institutionIntrosTextNum(state: State): number {
    const tempArr: Array<IntroItem> = state.institutionIntros.filter(item => {
      return item.type === 'text';
    });
    return tempArr.length;
  },
  institutionIntrosImgNum(state: State): number {
    const tempArr: Array<IntroItem> = state.institutionIntros.filter(item => {
      return item.type === 'img';
    });
    return tempArr.length;
  },
  institutionIntrosVideoNum(state: State): number {
    const tempArr: Array<IntroItem> = state.institutionIntros.filter(item => {
      return item.type === 'video';
    });
    return tempArr.length;
  },

  courseDesc(state: State): Array<DescItem> {
    return state.distributeTypeParameter.courseDesc;
  },
  courseDescTextNum(state: State): number {
    const tempArr: Array<DescItem> = state.distributeTypeParameter.courseDesc.filter(item => {
      return item.type === 'text';
    });
    return tempArr.length;
  },
  courseDescImgNum(state: State): number {
    const tempArr: Array<DescItem> = state.distributeTypeParameter.courseDesc.filter(item => {
      return item.type === 'img';
    });
    return tempArr.length;
  },
  courseDescVideoNum(state: State): number {
    const tempArr: Array<DescItem> = state.distributeTypeParameter.courseDesc.filter(item => {
      return item.type === 'video';
    });
    return tempArr.length;
  },
  viewBackground(state: State): string {
    return state.viewBackground;
  },
  bgmIcon(state: State): string {
    return state.bgmIcon;
  },
  contactIcon(state: State): string {
    return state.contactIcon;
  },
  posterIcon(state: State): string {
    return state.posterIcon;
  },
  scanBackground(state: State): string {
    return state.scanBackground;
  },
  scanTextColor(state: State): string {
    return state.scanTextColor;
  },
  scanSubTextColor(state: State): string {
    return state.scanSubTextColor;
  },
  scanNumber(state: State): string {
    return state.scanNumber;
  },

  releaseStatus(state: State): string {
    return state.releaseStatus;
  },
  joinNumber(state: State): string {
    return state.joinNumber;
  },
  supportPay(state: State): boolean {
    return state.supportPay;
  },
  channel(state: State): string {
    return state.channel;
  },

  coverTiny(state: State): string {
    return state.coverTiny;
  },
  iWantDoIcon(state: State): string {
    return state.iWantDoIcon;
  },
  inviteIcon(state: State): string {
    return state.inviteIcon;
  },
  limitFlag(state: State): boolean {
    return state.limitFlag;
  },
  limitFlagNumber(state: State): number {
    return state.limitFlagNumber;
  },
  showExtId(state: State): string {
    return state.showExtId;
  },
  bargainParameter(state: State): BargainParameterState {
    // 砍价活动参数
    const bargainParameter = state.bargainParameter;
    const item = { ...bargainParameter };
    return item;
  },
  tyTypeParameter(state: State): TyTypeParameterState {
    const tyTypeParameter = state.tyTypeParameter;
    let item = {} as any;
    item.prizeNum = Number(tyTypeParameter.prizeNum);
    item.prizeLeftCount = Number(tyTypeParameter.prizeLeftCount);
    item.unitNum = Number(tyTypeParameter.unitNum);
    item.goodValue = Number(tyTypeParameter.goodValue);
    item.normalValue = Number(tyTypeParameter.normalValue);
    item.badValue = Number(tyTypeParameter.badValue);
    item.unitTitle = tyTypeParameter.unitTitle;
    item.vebStr = tyTypeParameter.vebStr;
    item.unitStr = tyTypeParameter.unitStr;
    item.intervalTime = Number(tyTypeParameter.intervalTime);
    return item;
  },
  chooseDegree(state: State): any {
    return state.chooseDegree;
  },
  rankList(state: State): Array<any> {
    return state.rankList;
  },
  urlUid(state: State): string {
    return state.urlUid;
  },
  chance(state: State): number {
    return state.chance;
  },
  count(state: State): number {
    return state.count;
  },
  groupSwitch(state: State): boolean {
    return state.groupSwitch;
  },
  unGroupSwitch(state: State): boolean {
    return state.unGroupSwitch;
  },
  autoCancel(state: State): boolean {
    return state.autoCancel;
  },
  groupImageList(state: State): Array<string> {
    return state.groupImageList;
  },

  groupSliderList(state: State): Array<string> {
    return new Array().concat(state.viewBackground, state.groupImageList);
  },

  groupList(state: State): Array<object> {
    return state.groupList;
  },
  groupCreateNumber(state: State): number {
    return state.groupCreateNumber;
  },
  groupCompleteNumber(state: State): number {
    return state.groupCompleteNumber;
  },
  groupFullNumber(state: State): number {
    return state.groupFullNumber;
  },
  groupFull(state: State): boolean {
    return state.groupFull;
  },
  showFooter(state: State): boolean {
    return state.showFooter;
  },
  hasPay(state: State): number {
    return state.hasPay;
  },
  cancel(state: State): boolean {
    return state.cancel;
  },
  hasSignIn(state: State): boolean {
    return state.hasSignIn;
  },

  showJoinFooter(state: State): boolean {
    return state.showJoinFooter;
  },
  joinGroupFlag(state: State): boolean {
    return state.joinGroupFlag;
  },
  contactQrcode(state: State): string {
    return state.contactQrcode;
  },
  signupItemConfig(state: State): string {
    return JSON.parse(state.signupItemConfig);
  },
  userAwardInfo(state: State): any {
    return state.userAwardInfo;
  },
  showBarrage(state: State): boolean {
    return state.showBarrage;
  },
  showNum(state: State): boolean {
    return state.showNum;
  },
  showData(state: State): boolean {
    return state.showData;
  },
  xmMajordomo(state: State): boolean {
    return state.xmMajordomo;
  },
  xcxType(state: State): string {
    return state.xcxType;
  },
  posterName(state: State): string {
    return state.posterName;
  },
  posterAvatar(state: State): string {
    return state.posterAvatar;
  },
  posterUrl(state: State): string {
    return state.posterUrl;
  },
  version(state: State): string {
    return state.version;
  },
  showWantDo(state: State): boolean {
    return state.showWantDo;
  },
  ladderGroupList(state: State): Array<Ladder> {
    return state.ladderGroupList || [];
  },
  headReward(state: State): string {
    return state.headReward;
  },
  posterImage(state: State): string {
    return state.posterImage;
  },
  leftQuota(state: State): number {
    return state.leftQuota;
  },
  solitaireList(state: State): Array<Solitaire> {
    return state.solitaireList || [];
  },
  solitaireingList(state: State): Array<Object> {
    return state.solitareingList;
  },
  hasPaidNumber(state: State): number {
    return state.hasPaidNumber;
  },
  hasMaterialSaved(state: State): boolean {
    return state.hasMaterialSaved;
  },
  hasInstOpenSMSVerify(state: State): boolean {
    return state.hasInstOpenSMSVerify;
  },
  smsRemainNumber(state: State): number {
    return state.smsRemainNumber;
  },
  showPayEditModal(state: State): boolean {
    return state.showPayEditModal;
  },
  showInValidModal(state: State): boolean {
    return state.showInValidModal;
  },
  needLimitNormalStu(state: State): boolean {
    return state.needLimitNormalStu;
  },
  selectedCardIndex(state: State): number {
    return state.selectedCardIndex;
  },
  gachaLoading(state: State): boolean {
    return state.gachaLoading;
  },
  gachaStart(state: State): boolean {
    return state.gachaStart;
  },
  studentInfo(state: State): object {
    return state.studentInfo;
  },
  detailLoaded(state: State): boolean {
    return state.detailLoaded;
  },
  showWesiteBtn(state: State): boolean {
    return state.showWesiteBtn;
  },
  avatar(state: State): string {
    return state.avatar;
  },
  nickname(state: State): string {
    return state.nickname;
  },
  distributeOrderCreateTime(state: State): number {
    return state.distributeOrderCreateTime;
  },
  myReward(state: State): number {
    return state.myReward;
  },
  distributePurchaseList(state: State): Array<object> {
    return state.distributePurchaseList;
  },
  distributeTradeId(state: State): string {
    return state.distributeTradeId;
  },
  distributeTabFixed(state: State): boolean {
    return state.distributeTabFixed;
  }
};

export default getters;